import _ from "lodash";
import { api } from "../Configurations/axios";

interface PostFileFinepProps {
    registerId: string,
    pathName: string,
    docType: 0 | 1 | 2 | 3 | 4 | 5,
    userEmail: string
}

const PostFileFinep = async (formData: any, { docType, pathName, registerId, userEmail }: PostFileFinepProps) => {
    try {
        const result = await api.post('/FilesFinep/Post', formData, {
            params: {
                registerId: registerId,
                pathName: pathName,
                docType: docType,
                userEmail: userEmail
            }
        });

        const response = await result.data;

        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const ValidateFileFinep = async (fileFinepId: string, isValid: boolean) => {
    try {
        const result = await api.put('/FilesFinep/ValidateFile', null, {
            params: {
                id: fileFinepId,
                isValid: isValid
            }
        });

        const response = await result.data;

        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const DeleteFileFinep = async (fileId: string) => {
    try {
        const result = await api.delete('/FilesFinep/DeleteFile', {
            params: {
                id: fileId
            }
        });

        const response = await result.data;

        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const GetFilesFinep = async (registerId: string) => {
    try {
        const result = await api.get(`/FilesFinep/GetByregistrationDocumentsId/${registerId}`);
        const response = await result.data;

        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

export {
    ValidateFileFinep,
    GetFilesFinep,
    PostFileFinep,
    DeleteFileFinep
}